module.exports = __webpack_public_path__ + "media/images/feedback_received-fe28b792.svg";